import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { baseurl, imageUrl } from "../Baseurl";

const CategoriesSub = () => {
  const { slug } = useParams(); // Get category slug from URL
  const navigate = useNavigate();
  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch category or submenu data
  const fetchCategoryData = async () => {
    try {
      const response = await axios.get(`${baseurl}getMainMenuBySlug/${slug}`);
      const data = response.data;

      console.log("Response:", data);

      if (data.type === "category") {
        navigate(`/shop/${slug}`); // Redirect if it's a category
      } else {
        setMenuData(data);
      }
      
      setLoading(false);
    } catch (err) {
      console.error("Error fetching category data:", err);
      setError("Failed to load category.");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, [slug]);

  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-4">
          <div className="col-md-12">
            <h4 className="product-desc-title">All Category</h4>

            {loading ? (
              <div className="d-flex justify-content-center align-items-center vh-50">
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : menuData?.type === "menu" ? (
              <div className="row g-2">
                {Array.isArray(menuData.data) ? (
                  menuData.data.length > 0 ? (
                    menuData.data.map((submenu) => (
                      <div className="col-md-2 col-6 submenu-card" key={submenu.id}>
                        <Link to={`/sub-categories/${submenu.slug}`} className="submenu-link">
                          <img src={`${imageUrl}menu/${submenu.image}`} alt={submenu.title} className="img-fluid" />
                          <h5>{submenu.title}</h5>
                        </Link>
                      </div>
                    ))
                  ) : (
                    <div className="text-center">
                      <p>No subcategories available.</p>
                    </div>
                  )
                ) : menuData.data ? (
                  <div className="col-md-2 col-6 submenu-card">
                    <Link to={`/sub-categories/${menuData.data.slug}`} className="submenu-link">
                      <img src={`${imageUrl}menu/${menuData.data.image}`} alt={menuData.data.title} className="img-fluid" />
                      <h5>{menuData.data.title}</h5>
                    </Link>
                  </div>
                ) : (
                  <div className="text-center">
                    <p>No subcategories available.</p>
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center">
                <p>No subcategories available.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CategoriesSub;
